
import { Component, Vue, Watch } from 'vue-property-decorator';
import { Progress } from 'element-ui';
import { State, Mutation } from 'vuex-class';
import { CountUp, CountUpOptions } from 'countup.js';
import { IORGSTATE } from '@/store/state.d';
import api from '@/api/org';

type Count<T, V> = {
  dayCount: T | V,
  monthCount: T | V,
  totalCount: T | V,
}

@Component({
  components: {
    Progress,
  },
})
export default class InfoCard extends Vue {
  @State(state => state.org.moduleUpdate.recharge) curStatus!: boolean;

  @Mutation('org/SET_ORG_RECHARGE_STATUS') setRechargeStatus !: Function;

  private countUp: Count<CountUp, null> = {
    dayCount: null,
    monthCount: null,
    totalCount: null,
  };

  public $refs!: {
    day: HTMLElement,
    month: HTMLElement,
    total: HTMLElement,
  };

  private countOpts: CountUpOptions = {
    prefix: '￥',
    decimal: '.',
    decimalPlaces: 2,
  };

  private loading: Boolean = true;

  private percentage: Number = 0;

  private colors: Array<{ color: string, percentage: number }> = [
    { color: '#f56c6c', percentage: 50 },
    { color: '#1989fa', percentage: 100 },
  ];

  private countDefault: CountUpOptions = {
    prefix: '￥',
    decimal: '.',
    decimalPlaces: 2,
  }

  mounted() {
    this.countUp.dayCount = new CountUp(this.$refs.day, 0, this.countDefault);
    this.countUp.monthCount = new CountUp(this.$refs.month, 0, this.countDefault);
    this.countUp.totalCount = new CountUp(this.$refs.total, 0, this.countDefault);
    this.getOrgRecharge();
  }

  // 根据机构Pid来获取机构充值
  getOrgRecharge() {
    this.loading = true;
    api.getOrgRecharge({ orgPid: this.$route.params.pid || '' }).then((res: any) => {
      (this.countUp.dayCount as CountUp).update(res.dayRecharge);
      (this.countUp.monthCount as CountUp).update(res.monthRecharge);
      (this.countUp.totalCount as CountUp).update(res.totalRecharge);
      this.percentage = res.totalRecharge > 0
        ? Math.floor(res.monthRecharge * 100 / res.totalRecharge * 100) / 100 : 0;
      this.setRechargeStatus(false);
      this.loading = false;
    });
  }

  @Watch('curStatus', { immediate: false, deep: true })
  handleStatusChange(v: boolean) {
    if (v) this.getOrgRecharge();
  }
}
